/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { ToastManager } from '@crystaldelta/loree-ui-components';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  createContent,
  getContent,
  editContent,
  createGlobalContent,
  createOpenInteractive,
  updateOpenInteractive,
  fetchCollabViewWithConfig,
  fetchTemplateViewWithConfig,
} from '../../middleware/api';
import { initializeReactGA } from '../../middleware/googleAnalytics';
import CircleLoader from '../loader/loader';
import { appendCustomFontUrlToHeader, getModalDetails } from '../../middleware/utils';
import { ReactComponent as Collapse1 } from '../../assets/icons/expandIcon.svg';
import { ReactComponent as Collapse2 } from '../../assets/icons/collapse.svg';
import ComponentBody from './componentBody';
import CustomizeComponent from './customizeLayout';
import {
  getInteractiveTitle,
  getLibraryId,
  setEditValue,
  getComponentCustomValues,
  removeEmptyTags,
  setContentArray,
} from './utils';
import PreviewComponent from './preview';
import store from '../../redux/store';
import { getValidationFunction, validateButtonForm, validateChecklistForm } from './validate';
import { handleButtonSubmit, checkInteractiveTitle } from './button/utils';
import { mapDispatchToProps, mapStateToProps } from './formPropsData';
import ModalComponent from '../utils/modal';
import './form.scss';
import NoContentComponent from '../../204';
import { getFeaturesList, updateCollabInteractiveParent } from '../interactiveManagement/utils';
import { ParentDataInterface } from '../../redux/parentDataSlice';
import { reset } from '../../redux/embedInterctive';
import { useHistory, useLocation } from 'react-router-dom';
import { TypeStateData } from '../../redux/handleBrowserBack';

interface ResponseType {
  error: any;
  id: string;
}
interface FailType {
  title?: string;
  fontSize?: string;
  btnFontSize?: string;
}

export function FormComponent(props: any) {
  const [opened, setOpened] = useState(true);
  const [alreadyExist, setAlreadyExist] = useState<string | null>(null);
  const [Modelshow, setModelshow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [saveType, setSaveType] = useState('private');
  const [isEdit, setIsEdit] = useState(true);
  const [config, setConfig] = useState({});
  const [editContentData, setEditContentData] = useState({});
  const [doesNotExists, setDoesNotExtis] = useState(false);
  const [modalType, setModalType] = useState('');
  const [removeListener, setRemoveListener] = useState(false);
  const redirectUrl = {
    homeUrl: '/library',
    myInteractiveUrl: '/interactives',
    globalInteractiveUrl: '/global',
  };
  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  const interactiveState = useSelector(
    (state: ParentDataInterface) => state.parentData.interactiveState,
  );
  const isCollaborative = interactiveState === 'collaborative';
  const customConfiguration = useSelector(
    (state: ParentDataInterface) => state.parentData.customConfiguration,
  );
  const isParentEdit = dataFromParent.isParentEdit ?? false;

  const { errors, title } = props;
  const { id, type } = props.match.params;
  const configCheck = customConfiguration ? customConfiguration.config : config;
  let customConfigsList = useRef(configCheck);
  const [customHeaderStylesPropsList, setCustomHeaderStylesPropsList] = useState(
    customConfiguration?.customHeaderStyleList?.customHeader ?? [],
  );
  const [customLinkStylesPropsList, setCustomLinkStylesPropsList] = useState(
    customConfiguration?.customLinkStyleList?.customLink ?? [],
  );
  const [fontFamilyPropsList, setFontFamilyPropsList] = useState(
    customConfiguration?.fontFamilyList.fonts ?? [],
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const historyProps = useHistory();
  const TypeInteractive = useSelector((state: TypeStateData) => state.typeSlice.values);
  useEffect(() => {
    const handlePop = (e: PopStateEvent) => {
      if (removeListener) return;
      setShowModal(true);
      setModalType('cancel');
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getTitleValue = () => {
    switch (type) {
      case 'multiplechoice':
        return props.mcqTitle;
      default:
        return title;
    }
  };

  const getErrorValue = () => {
    switch (type) {
      case 'Button':
        return props.buttonError;
      case 'multiplechoice':
        return props.mcqError;
      default:
        return errors;
    }
  };
  const getTitleFunction = () => {
    const { HandleTitle, HandleFlipCardTitle, HandleMcqTitle } = props;
    switch (type) {
      case 'flipcard':
        return HandleFlipCardTitle;
      case 'multiplechoice':
        return HandleMcqTitle;
      default:
        return HandleTitle;
    }
  };
  const handleTitleChange = getTitleFunction();

  // toggle the collapse ID for changing the accordion icon
  const toggleBox = () => {
    setOpened(!opened);
  };
  const getEditFunction = () => {
    const { MakeEdit, MakeFlipCardEdit, MakeMcqEdit } = props;
    switch (type) {
      case 'flipcard':
        return MakeFlipCardEdit;
      case 'multiplechoice':
        return MakeMcqEdit;
      default:
        return MakeEdit;
    }
  };

  const getInteractiveDataFromId = async (id: string) => {
    try {
      switch (true) {
        case isCollaborative && dataFromParent.collabType === 'page':
          return await fetchCollabViewWithConfig(id, dataFromParent.userId);
        case isCollaborative && dataFromParent.collabType === 'template':
          return await fetchTemplateViewWithConfig(id, dataFromParent.userId);
        default:
          return await getContent(id, dataFromParent.userId);
      }
    } catch (error) {
      console.error('Error fetching content data:', error);
      return null;
    }
  };

  useEffect(() => {
    historyProps.push(location.pathname);
    if (!dataFromParent) {
      return props.history.push('/401');
    }
    const fetchData = async () => {
      try {
        const {
          SetType,
          SetValue,
          SetMcqValue,
          dndLayout,
          ResetButtonStore,
          ResetFlipStore,
          ResetFormStore,
          ResetMcqStore,
          ResetComponentStore,
        } = props;
        const { type, id } = props.match.params;
        const { pathname } = props.location;
        initializeReactGA(pathname, dataFromParent);
        SetType({
          type: type,
        });
        ResetButtonStore();
        ResetFlipStore();
        ResetFormStore();
        ResetMcqStore();
        ResetComponentStore();
        if (!dataFromParent) {
          window.location.href = '/401';
        } else if (id) {
          const data = await getInteractiveDataFromId(id);
          let config = data.config ? JSON.parse(data.config) : {};
          config = getFeaturesList(config, '');
          setConfig(config);
          customConfigsList.current = JSON.parse(data.config)?.configsList;

          if (data.info) {
            setDoesNotExtis(true);
            return;
          }

          setEditContentData(data);
          if (data.message === 'Unauthorized User or Invalid Content') {
            return props.history.push('/401');
          }

          if (type !== 'Button' && type !== 'checklist') {
            let parameters = JSON.parse(data.parameters);
            setAlreadyExist(
              pathname.includes('duplicate')
                ? 'DUPLICATED INTERACTIVE - Please enter a new title'
                : null,
            );
            setEditValue(
              type,
              data,
              setContentArray(
                parameters,
                type,
                type === 'multiplechice' ? SetMcqValue : SetValue,
                dndLayout,
              ),
              parameters,
              pathname,
              getEditFunction(),
            );
          }
        }
        let fontFamilyConfigList =
          customConfiguration?.fontFamilyList ?? customConfigsList.current?.customFonts;
        let customHeaderStyleList =
          customConfiguration?.customHeaderStyleList ??
          customConfigsList.current?.customHeaderStyle;
        appendCustomFontUrlToHeader(fontFamilyConfigList.fonts ?? []);
        fontFamilyPropsList.length === 0 &&
          setFontFamilyPropsList(fontFamilyConfigList.fonts ?? []);
        customHeaderStylesPropsList.length === 0 &&
          setCustomHeaderStylesPropsList(customHeaderStyleList?.customHeader ?? []);
        customLinkStylesPropsList.length === 0 &&
          setCustomLinkStylesPropsList(customConfiguration?.customLinkStyleList ?? []);
        setIsEdit(!isEdit);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  //value from title within the panel
  const handleChange = (i: any, event: React.ChangeEvent) => {
    const { errors, parameters, HandleChange } = props;
    const { value } = event.target as HTMLInputElement;
    let fail = errors;
    const currentType = props.match.params.type;
    let length = currentType === 'DragandDrop' ? 100 : 250;
    if (currentType === 'DragandDrop' || value.length < length) {
      let content = [...parameters];
      content[i] = { ...content[i], title: !value.trim() ? '' : value };
      HandleChange({
        parameters: content,
        errors: fail,
      });
    }
  };

  // value from main-title
  const handleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setAlreadyExist(null);
    if (props.location.pathname.includes('/duplicate')) {
      setAlreadyExist(value === '' ? '* DUPLICATED INTERACTIVE - Please enter a new title' : null);
    }
    if (value.length < 256) {
      handleTitleChange({
        title: value.replace(/ +/g, ' '),
      });
    }
  };

  const updateInteractiveContent = async (id: string, data: any, collabData: any) => {
    switch (true) {
      case interactiveState === 'collaborative' && dataFromParent.collabType === 'page':
        return await updateOpenInteractive(
          {
            id,
            body: collabData,
          },
          'paginated-lint',
        );
      case interactiveState === 'collaborative' && dataFromParent.collabType === 'template':
        return await updateOpenInteractive(
          {
            id,
            body: collabData,
          },
          'templated-lint',
        );
      default:
        return await editContent({
          id,
          body: data,
        });
    }
  };

  const createInteractiveContent = async (data: any, collabData: any) => {
    switch (true) {
      case interactiveState === 'collaborative' && dataFromParent.collabType === 'page':
        return await createOpenInteractive(collabData, 'paginated-lint');
      case interactiveState === 'collaborative' && dataFromParent.collabType === 'template':
        return await createOpenInteractive(collabData, 'templated-lint');
      default:
        return await createContent(data);
    }
  };

  //sumbit the form values to database and send response to preview page
  const handleSubmit = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    isGlobal: boolean,
  ) => {
    const itIsGlobal =
      (isGlobal && !configCheck.myinteractivecreate) ||
      (saveType === 'global' &&
        configCheck.globalinteractivecreate &&
        configCheck.myinteractivecreate);
    const { title, ErrorsFetch, dndLayout } = props;
    let { id, type } = props.match.params;
    let response: ResponseType = {
      id: '',
      error: {},
    };
    const typeid = getLibraryId(type);
    removeEmptyTags(getParameters(), type);
    event.preventDefault();
    const validationFunction = getValidationFunction(type, dndLayout);
    let fail: FailType = validationFunction(props, ErrorsFetch, props.location.pathname, type);
    let dupicatetitle =
      fail.title === 'DUPLICATED INTERACTIVE - Please enter a new title'
        ? delete fail['title']
        : null;
    if (Object.keys(fail).length === 0 && alreadyExist === null) {
      const titleValue = title.trim();
      let data = {
        user_id: dataFromParent.userId,
        library_id: typeid,
        id,
        organization_id: dataFromParent.orgId,
        title: titleValue,
        parameters: JSON.stringify(getParameters()),
        customisations: {
          ...getComponentCustomValues(type, props),
          fontsList: JSON.stringify(fontFamilyPropsList),
        },
        active: true,
        private: !itIsGlobal,
        global: itIsGlobal,
        editable: itIsGlobal,
      };
      let collabData: any = {
        course_id: dataFromParent.courseId,
        page_id: dataFromParent.pageId,
        interactive_title: titleValue,
        organization_id: dataFromParent.orgId,
        platform_id: dataFromParent.ltiPlatformId,
        created_by: dataFromParent.userId,
        jsonContent: {
          library_id: typeid,
          type,
          parameters: JSON.stringify(getParameters()),
          customisations: {
            ...getComponentCustomValues(type, props),
            fontsList: JSON.stringify(fontFamilyPropsList),
          },
        },
      };
      if (id) {
        if (props.location.pathname.includes('/duplicate') && dupicatetitle === null) {
          response = await createContent(data);
          if (response.error) {
            setAlreadyExist('Title already exist, Please enter a new title');
            return;
          }
          setShowToast(true);
          setToastMessage('Content duplicated successfully');
        } else {
          response.id = id;
          collabData.updated_by = dataFromParent.userId;
          const updateResponse = await updateInteractiveContent(id, data, collabData);
          if (updateResponse.error) {
            setAlreadyExist('Title already exist, Please enter a new title');
            return;
          }
          setShowToast(true);
          setToastMessage(
            'Content updated successfully. Page is redirect to the view of the updated element',
          );
        }
      } else if (type) {
        response = await createInteractiveContent(data, collabData);
        if (itIsGlobal) {
          const globalData = {
            organization: dataFromParent.orgId,
            title: titleValue,
            interactiveIds: response.id,
            accessType: 'global',
            accountIds: '',
            editable: 'write',
          };
          await createGlobalContent(globalData);
        }
        if (response.error) {
          setAlreadyExist('Title already exist, Please enter a new title');
          return;
        }
      }
      redirectToView(type, response.id);
    }
  };

  const modalToggle = (event: { preventDefault: () => void }) => {
    if (type === 'Button') {
      const buttonStateCollection = store.getState().button;
      const error = validateButtonForm(buttonStateCollection, props.SetButtonFormError);
      if (Object.keys(error).length === 0) {
        setModelshow(true);
      }
      return;
    }
    if (type === 'checklist') {
      const checklistItemsData = store.getState().button;
      const error = validateChecklistForm(checklistItemsData, props.SetButtonFormError);
      if (Object.keys(error).length === 0) {
        setModelshow(true);
      }
      return;
    }
    const { title, ErrorsFetch, dndLayout } = props;
    event.preventDefault();
    removeEmptyTags(getParameters(), type);
    const validationFunction = getValidationFunction(type, dndLayout);
    let fail = validationFunction(props, ErrorsFetch, props.location.pathname, type);
    if (title.trim() === '') {
      return;
    }
    if (Object.keys(fail).length === 0) {
      setModelshow(true);
    }
  };

  const Modelclose = () => {
    setModelshow(false);
  };

  const getPreviewProps = () => {
    switch (type) {
      case 'Button':
      case 'checklist':
        return store.getState().button;
      case 'flipcard':
        return store.getState().flipform;
      case 'multiplechoice':
        return store.getState().mcqform;
      default:
        return props;
    }
  };

  const getAddPannelFunction = () => {
    switch (type) {
      case 'flipcard':
        return props.addFlipCardPanels;
      case 'multiplechoice':
        return props.addMcqPannel;
      case 'DragandDrop':
        return props.dndLayout === 'CustomOverlay' ? props.AddDndSection : props.addPanels;
      case 'Hotspot':
        return props.AddDndSection;
      default:
        return props.addPanels;
    }
  };

  const getParameters = () => {
    switch (type) {
      case 'flipcard':
        return props.flipCardParameters;
      case 'multiplechoice':
        return props.mcqParameters;
      case 'DragandDrop':
        return props.dndLayout === 'CustomOverlay' ? props.dndParameters : props.parameters;
      case 'Hotspot':
        return props.dndParameters;
      default:
        return props.parameters;
    }
  };

  const getContentArray = () => {
    switch (type) {
      case 'flipcard':
        return props.flipCardContentArr;
      case 'multiplechoice':
        return props.mcqContentArr;
      case 'DragandDrop':
        return props.dndLayout === 'CustomOverlay' ? props.dndArray : props.contentArr;
      case 'Hotspot':
        return props.dndArray;
      default:
        return props.contentArr;
    }
  };
  const createInteractiveModal = () => {
    return {
      title: 'Create Interactive',
      body: (
        <div style={{ fontSize: '16px' }}>
          <p className='mb-2'>Create your interactive as: </p>
          <Form.Check
            label='My Interactive'
            name='createInteractiveButton'
            type='radio'
            value='private'
            id='private-button'
            onChange={() => setSaveType('private')}
            checked={saveType === 'private'}
            className='mb-2 icon-label createInteractiveButton'
          />
          <Form.Check
            label='Global Interactive'
            name='createInteractiveButton'
            type='radio'
            value='global'
            id='global-button'
            onChange={() => setSaveType('global')}
            checked={saveType === 'global'}
            className='icon-label createInteractiveButton'
          />
        </div>
      ) as ReactNode,
    };
  };

  const handletriggerCreateModal = async () => {
    const { ErrorsFetch, dndLayout, title, SetButtonFormError } = props;
    let fail: FailType = {};
    if (type !== 'Button' && type !== 'checklist') {
      const validationFunction = getValidationFunction(type, dndLayout);
      fail = validationFunction(props, ErrorsFetch, props.location.pathname, type);
    } else if (type === 'checklist') {
      const checklistItems = store.getState().button;
      const failButton = validateChecklistForm(checklistItems, SetButtonFormError);
      if (Object.keys(failButton).length > 0) return;
      const showNextStep = await checkInteractiveTitle({
        title: checklistItems.title,
        organization_id: dataFromParent.orgId,
      });
      if (showNextStep) {
        setShowModal(true);
      } else {
        SetButtonFormError({
          errors: { title: 'Title already exist, Please enter a new title' },
        });
      }
      return;
    } else {
      const buttonStateCollection = store.getState().button;
      const failButton = validateButtonForm(buttonStateCollection, SetButtonFormError);
      if (failButton.title || failButton.name || failButton.link) {
        return;
      }
      const showButtonNextStep = await checkInteractiveTitle({
        title: buttonStateCollection.title,
        organization_id: dataFromParent.orgId,
      });
      if (showButtonNextStep) {
        setShowModal(true);
      } else {
        SetButtonFormError({
          errors: { title: 'Title already exist, Please enter a new title' },
        });
      }
      return;
    }
    if (Object.keys(fail).length === 0) {
      const showNextStep = await checkInteractiveTitle({
        title,
        organization_id: dataFromParent.orgId,
      });
      if (showNextStep) {
        setShowModal(true);
      } else {
        setAlreadyExist('Title already exist, Please enter a new title');
      }
    }
  };

  const handleButtonEvent = async (id?: string) => {
    const itIsGlobal =
      (configCheck.globalinteractivecreate && !configCheck.myinteractivecreate) ||
      (saveType === 'global' &&
        configCheck.globalinteractivecreate &&
        configCheck.myinteractivecreate);
    const response: { message: string; id: string } = await handleButtonSubmit(
      props,
      itIsGlobal,
      customConfiguration || config,
      dataFromParent,
      type,
      isCollaborative,
      id,
    );
    if (response === undefined) return;
    handleButtonEventToast(response);
    redirectToView(type, id ?? response.id);
  };

  const redirectToView = (type: string, id: string) => {
    if (isParentEdit) {
      updateCollabInteractiveParent();
    } else {
      setTimeout(() => {
        props.history.push({
          pathname: `/contentview/${type}/${id}`,
        });
      }, 2000);
    }
  };

  const handleCancel = () => {
    setRemoveListener(true);
    if (isParentEdit) {
      updateCollabInteractiveParent();
    } else if (location.key) {
      props.history.push(TypeInteractive);
    } else {
      props.history.push(
        configCheck.myinteractivecreate || configCheck.globalinteractivecreate
          ? redirectUrl.homeUrl
          : configCheck.myinteractive
          ? redirectUrl.myInteractiveUrl
          : configCheck.globalinteractive
          ? redirectUrl.globalInteractiveUrl
          : '/shared',
      );
    }
  };
  const handleButtonEventToast = (response: { message: string }) => {
    switch (true) {
      case response.message === 'Content Updated':
        setShowToast(true);
        setToastMessage(
          'Content updated successfully. Page is redirect to the view of the updated element',
        );
        break;
      case props.location.pathname.includes('/duplicate'):
        setShowToast(true);
        setToastMessage(
          'Content duplicated successfully. Page is redirect to the view of the updated element',
        );
        break;
    }
  };
  const handleEmbedDataEmpty = () => {
    props.setMyinteractive([]);
    props.setGlobalInteractive([]);
    props.setSharedInteractive([]);
    dispatch(reset());
  };
  return (
    <>
      {doesNotExists && <NoContentComponent />}
      {id && isEdit && !doesNotExists && (
        <Row>
          <CircleLoader loaderType='' />
        </Row>
      )}
      {!doesNotExists && !isEdit && (
        <>
          <Container fluid className='margin' id='interactiveMargin'>
            <div className='d-flex flex-wrap'>
              {opened && (
                <CustomizeComponent
                  {...props}
                  elementType={type}
                  fontFamilyPropsList={fontFamilyPropsList}
                  customHeaderStylesPropsList={customHeaderStylesPropsList}
                  customLinkStylesPropList={customLinkStylesPropsList}
                  isCollaborative={isCollaborative}
                />
              )}
              <div
                className={`${opened ? 'form-wrapper' : 'w-100'} ${
                  isCollaborative ? 'openInteractive' : ''
                }`}
              >
                <div
                  className='customize-toggle my-3'
                  onClick={toggleBox}
                  tabIndex={0}
                  onKeyDown={toggleBox}
                  role='button'
                >
                  {!opened ? <Collapse1 /> : <Collapse2 />}
                </div>
                <Row className='component-body mr-2 w-100' style={{ position: 'sticky', top: '0' }}>
                  <div
                    className={`d-flex flex-row p-0 justify-content-between accordion-nav ${
                      isCollaborative ? 'openInteractive' : ''
                    }`}
                  >
                    <Col
                      className='text-capitalize h4 fw-bolder'
                      style={{
                        marginBottom: '10px',
                        padding: '10px',
                      }}
                    >
                      <span
                        className={`title-text ${isCollaborative ? 'openInteractive' : ''}`}
                        style={{
                          color: '#0B099C',
                          fontFamily: 'Lexend',
                          fontWeight: 400,
                          fontSize: '18px',
                        }}
                      >
                        {getInteractiveTitle(type)}
                        {isCollaborative ? ' - Open Interactive' : ''}
                      </span>
                    </Col>
                    <Button className='preview-button' onClick={modalToggle} size='sm'>
                      Preview
                    </Button>
                    {Modelshow && (
                      <PreviewComponent
                        content={getPreviewProps()}
                        show={Modelshow}
                        onHide={Modelclose}
                        type={type}
                      />
                    )}
                  </div>
                </Row>
                <ComponentBody
                  id={id}
                  editContentData={editContentData}
                  handleTitleChange={(e) => handleTitle(e)}
                  alreadyExist={alreadyExist}
                  titleValue={getTitleValue()}
                  errors={getErrorValue()}
                  contentArr={getContentArray()}
                  addPanelHandel={getAddPannelFunction()}
                  parameter={getParameters()}
                  number={props.num}
                  type={props.match.params.type}
                  handleChange={props.HandleChange}
                  handleTitle={(i: any, event: any) => handleChange(i, event)}
                  pathName={props.location.pathname}
                  optionId={props.mcqOptionId}
                  dndLayout={props.dndLayout}
                  editorConfig={{
                    customHeaderStyleList: customHeaderStylesPropsList,
                    fontFamilyList: fontFamilyPropsList,
                    customLinkStyleList: customLinkStylesPropsList,
                  }}
                />
              </div>
            </div>
            {showToast && (
              <ToastManager
                toastType='success'
                toastMessage={toastMessage}
                closeToast={() => setShowToast(false)}
                closeButton
              />
            )}
          </Container>
          <div className='footer-button-wrapper pb-2 pt-2'>
            <Button
              className='footer-cancel-btn mx-2'
              type='submit'
              id='global-lint'
              onClick={() => {
                setShowModal(true);
                setModalType('cancel');
              }}
            >
              Cancel
            </Button>
            {(configCheck.collaborativeinteractivecreate ||
              configCheck.myinteractivecreate ||
              configCheck.globalinteractivecreate) &&
              ((id && props.location.pathname.includes('/duplicate')) || !id) && (
                <Button
                  className='footer-create-btn mx-2'
                  id='global-lint'
                  type='submit'
                  onClick={(e) => {
                    setModalType('Create');
                    switch (type) {
                      case 'Button':
                        {
                          configCheck.myinteractivecreate &&
                          configCheck.globalinteractivecreate &&
                          !isCollaborative
                            ? void handletriggerCreateModal()
                            : handleButtonEvent();
                        }
                        break;
                      default:
                        {
                          configCheck.myinteractivecreate &&
                          configCheck.globalinteractivecreate &&
                          !isCollaborative
                            ? void handletriggerCreateModal()
                            : handleSubmit(e, configCheck.globalinteractivecreate);
                        }
                        break;
                    }
                  }}
                  disabled={
                    !configCheck.myinteractivecreate && !configCheck.globalinteractivecreate
                  }
                >
                  Create
                </Button>
              )}
            {(configCheck.collaborativeinteractiveedit ||
              configCheck.myinteractiveedit ||
              configCheck.globalinteractiveedit ||
              configCheck.sharedinteractiveedit) &&
              id &&
              !props.location.pathname.includes('/duplicate') && (
                <Button
                  className='footer-create-btn mx-2'
                  id='global-lint'
                  type='submit'
                  onClick={(e) => {
                    switch (type) {
                      case 'Button':
                        handleButtonEvent(id);
                        break;
                      default:
                        handleSubmit(e, configCheck.globalinteractivecreate);
                        break;
                    }
                  }}
                >
                  Update
                </Button>
              )}
            {!isCollaborative &&
              !configCheck.myinteractivecreate &&
              configCheck.globalinteractivecreate && (
                <p className='global-note-message m-0 mt-1'>
                  Note: This Interactive will create as Global
                </p>
              )}
          </div>
        </>
      )}
      <div className='footer-button-wrapper pb-2 pt-2'>
        <Button
          className='footer-cancel-btn mx-2'
          type='submit'
          id='global-lint'
          onClick={() => {
            setShowModal(true);
            setModalType('cancel');
            handleEmbedDataEmpty();
          }}
        >
          Cancel
        </Button>
        {(configCheck.collaborativeinteractivecreate ||
          configCheck.myinteractivecreate ||
          configCheck.globalinteractivecreate) &&
          ((id && props.location.pathname.includes('/duplicate')) || !id) && (
            <Button
              className='footer-create-btn mx-2'
              id='global-lint'
              type='submit'
              onClick={(e) => {
                setModalType('Create');
                switch (type) {
                  case 'Button':
                  case 'checklist':
                    {
                      configCheck.myinteractivecreate &&
                      configCheck.globalinteractivecreate &&
                      !isCollaborative
                        ? handletriggerCreateModal()
                        : handleButtonEvent();
                    }
                    break;
                  default:
                    {
                      configCheck.myinteractivecreate &&
                      configCheck.globalinteractivecreate &&
                      !isCollaborative
                        ? handletriggerCreateModal()
                        : handleSubmit(e, configCheck.globalinteractivecreate);
                      handleEmbedDataEmpty();
                    }
                    break;
                }
              }}
            >
              Create
            </Button>
          )}
        {(configCheck.collaborativeinteractiveedit ||
          configCheck.myinteractiveedit ||
          configCheck.globalinteractiveedit ||
          configCheck.sharedinteractiveedit) &&
          id &&
          !props.location.pathname.includes('/duplicate') && (
            <Button
              className='footer-create-btn mx-2'
              id='global-lint'
              type='submit'
              onClick={(e) => {
                switch (type) {
                  case 'Button':
                  case 'checklist':
                    handleButtonEvent(id);
                    break;
                  default:
                    handleSubmit(e, configCheck.globalinteractivecreate);
                    handleEmbedDataEmpty();
                    break;
                }
              }}
            >
              Update
            </Button>
          )}
        {!isCollaborative &&
          !configCheck.myinteractivecreate &&
          configCheck.globalinteractivecreate && (
            <p className='global-note-message m-0 mt-1'>
              Note: This Interactive will create as Global
            </p>
          )}
      </div>
      <ModalComponent
        show={showModal}
        handleCancel={() => setShowModal(false)}
        modalDetails={modalType === 'cancel' ? getModalDetails('Exit') : createInteractiveModal()}
        confirmButton={{
          label: modalType === 'cancel' ? 'Exit' : 'Create',
          disabled: false,
          handleConfirm: (e: any) =>
            modalType === 'cancel'
              ? handleCancel()
              : type === 'Button' || type === 'checklist'
              ? handleButtonEvent()
              : handleSubmit(e, configCheck.globalinteractivecreate),
        }}
        cancelButton={{
          label: modalType === 'cancel' ? 'Cancel' : 'Cancel',
        }}
      />
    </>
  );
}

//connecting form with redux
export default connect(mapStateToProps, mapDispatchToProps)(FormComponent);
